exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.table-resumen[data-v-c6537b36]{border-width:0}table.table-resumen tbody[data-v-c6537b36]{border-style:solid;border-color:#05bdbd;border-width:1px 0 0 1px}table.table-resumen td[data-v-c6537b36]{border-color:#05bdbd;border-width:0 1px 1px 0}.destacado[data-v-c6537b36]{background-color:#05bdbd;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c6537b36","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/BookingConfirmation.vue
// module id = 538
// module chunks = 0